// extracted by mini-css-extract-plugin
export var centeredWithMaxWidth = "BasePage-module--centered-with-max-width--e32da";
export var content = "BasePage-module--content--7cd00";